export default __webpack_public_path__ + "static/media/Interior (11).4a28e195.jpg";